<template>
    <main>
        <div class="common-report">
            <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
            <div class="lft-view report-side-panel bench-overview-side-panel q-box-shadow">
                <div class="sub-header">
                    <report-header @updateEvent="fetchUpdatedReport"></report-header>
                    <div class="engagement-range ">
                        <v-select
                                :options="engagements"
                                label="engagement"
                                clear-button-icon="false"
                                v-model="engagement" :searchable="false"
                        ></v-select>
                        <span class="range-per">%</span>
                    </div>
                    <div class="date-range">
                        <vue-monthly-picker
                                :clearOption="false"
                                v-model="startMonth"
                                :monthLabels="monthLabels"
                                :max="endMonth"
                                :min="startLimit"
                        ></vue-monthly-picker>
                        <vue-monthly-picker
                                :clearOption="false"
                                v-model="endMonth"
                                :monthLabels="monthLabels"
                                :min="startMonth"
                                :max="endLimit"
                        ></vue-monthly-picker>

                        <i class="csv-export button-export" @click.stop="exportExcel()"></i>
                    </div>
                </div>
                <!-- table set -->
                <div class="table-wrapper" ref="tableWrapperLap">
                    <div class="master-table-head-box master-t-head-b">
                        <div class="master-table-head consultant-workload">
                            <div class="consultant-w dropdown-setter left-pos-cell" data-setter="consultant">
                                <div
                                        class="master-table-text left-table-header"
                                        @click="sortTable('consultant')"
                                >Consultant
                                </div>
                                <div class="master-table-opt"></div>
                                <button
                                        type="button"
                                        class="vs-con-dropdown parent-dropdown"
                                        data-getter="consultant"
                                >
                                    <a href.prevent class="a-icon">
                                        <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i>  filter-icon-i filter-icon-i-active-->
                                        <i
                                                :class="(consultantSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"
                                        ></i>
                                    </a>
                                </button>
                                <Dropdown>
                                    <ul>
                                        <li>
                                            <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                                    type="text"
                                                    class="dropdown-input"
                                                    placeholder="Filter"
                                                    v-model="consultantSearch"
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                            <div class="co-w-thone-sap dropdown-setter" data-setter="sapno">
                                <div class="master-table-text left-table-header" @click="sortTable('sap_no')">
                                    SAP
                                    no
                                </div>
                                <div class="master-table-opt"></div>
                                <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="sapno">
                                    <a href.prevent class="a-icon">
                                        <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                                        <i :class="(sapSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                    </a>
                                </button>
                                <Dropdown>
                                    <ul>
                                        <li>
                                            <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                                    type="text"
                                                    class="dropdown-input"
                                                    placeholder="Filter"
                                                    :class="{'error-border':searchError.sap_no}"
                                                    v-model="sapSearch"
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                            <div class="co-w-thone-country dropdown-setter" data-setter="customer">
                                <div
                                        class="master-table-text left-table-header"
                                        @click="sortTable('customer')"
                                >Customer
                                </div>
                                <div class="master-table-opt"></div>
                                <button 
                                        type="button"
                                        class="vs-con-dropdown parent-dropdown"
                                        data-getter="customer"
                                >
                                    <a href.prevent class="a-icon">
                                        <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                                        <i :class="(customerSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                    </a>
                                </button>
                                <Dropdown>
                                    <ul>
                                        <li>
                                            <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                                    type="text"
                                                    class="dropdown-input"
                                                    placeholder="Filter"
                                                    v-model="customerSearch"
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                            <div class="co-w-thone dropdown-setter" data-setter="oe">
                                <div class="master-table-text left-table-header" @click="sortTable('oe')">OE</div>
                                <div class="master-table-opt"></div>
                                <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="oe">
                                    <a href.prevent class="a-icon">
                                        <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                                        <i :class="(oeSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                    </a>
                                </button>
                                <Dropdown>
                                    <ul>
                                        <li>
                                            <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                                    type="text"
                                                    class="dropdown-input"
                                                    placeholder="Filter"
                                                    v-model="oeSearch"
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                            <div class="co-w-thone dropdown-setter right-pos-cell" data-setter="employment">
                                <div
                                        class="master-table-text left-table-header"
                                        @click="sortTable('engagement')"
                                >Employment
                                </div>
                                <div class="master-table-opt"></div>
                                <button
                                        type="button"
                                        class="vs-con-dropdown parent-dropdown"
                                        data-getter="employment"
                                >
                                    <a href.prevent class="a-icon">
                                        <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                                        <i
                                                :class="(engagementSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"
                                        ></i>
                                    </a>
                                </button>
                                <Dropdown>
                                    <ul>
                                        <li>
                                            <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                                    type="text"
                                                    class="dropdown-input"
                                                    placeholder="Filter"
                                                    :class="{'error-border':searchError.employment}"
                                                    v-model="engagementSearch"
                                            />
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    <div
                            class="master-table master-report-table master-table-loaded"
                            v-bar
                            id="bench-scroll-table"
                    >
                        <scroll-sync group="report" ref="verticalscrollset" vertical>
                            <scroll-sync group="two" vertical>
                                <table-loader v-if="isLoadingMoreRows"></table-loader>
                                <template v-for="(relation, index) in relations">
                                    <bench-relation :key="index" :relation="relation"/>
                                </template>
                                <div class="no-item" v-if="relations.length < 1">No items found !</div>
                            </scroll-sync>
                        </scroll-sync>
                    </div>
                </div>
            </div>
            <div
                    class="rht-view report-allocations report-allocation-workload report-alloc-benchoverview"
                    ref="report-allocation" :class="(allocations.length == 0)? 'empty-view':'filled-view'"
            >
                <GeminiScrollbar class="my-scroll-bar hrscroll">
                    <div
                            class="table-container"
                            :style="{width: `${masterTableWidth}px`, minWidth: `${masterTableWidth}px`}"
                    >
                        <div class="master-head" ref="masterHeadScroll">
                            <template v-for="(allocation,index) in allocations">
                                <div class="master-head-month" :key="index">
                                    <h3 class="month-name">{{allocation.monthNameAndYear}}</h3>
                                </div>
                            </template>
                        </div>
                        <div class="table-wrapper">
                            <div class="master-table-head-box">
                                <div
                                        class="each-month each-month-header each-month-turnover-header"
                                        :key="index"
                                        v-for="(allocation,index) in allocations"
                                ></div>
                            </div>
                            <div class="master-table master-report-table master-table-loaded" v-bar>
                                <scroll-sync group="report" vertical>
                                    <template v-for="(allocation, index) in allocations">
                                        <bench-turnover :key="index" :allocation="allocation"/>
                                    </template>
                                </scroll-sync>
                            </div>
                        </div>
                    </div>
                </GeminiScrollbar>
            </div>
        </div>
    </main>
</template>
<script>
    import searchKeys from "../../../config/searchKeys";
    import VueMonthlyPicker from 'vue-monthly-picker' //https://www.npmjs.com/package/vue-monthly-picker

    const BenchRelation = () => import("./bench-overview/BenchRelation");
    const BenchTurnover = () => import("./bench-overview/BenchTurnover");
    const ReportHeader = () => import("./ReportHeader");
    const Dropdown = () => import('../../common/Dropdown');
    const TableLoader = () => import("../../common/TableLoader");
    import settings from "../../../config/settings";
    import _ from 'lodash';
    import moment from 'moment';

    export default {
        name: "BenchOverview",
        data: () => {
            return {
                masterTableWidth: 0,
                loadMore: true,
                timeout: 0,
                startMonth: moment(),
                endMonth: moment().add(3, 'M'),
                monthLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                searchError: {
                    sap_no: false,
                    employment: false,
                },
                engagements: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                engagement: 100
            }
        },
        components: {
            TableLoader,
            BenchTurnover,
            BenchRelation,
            ReportHeader,
            Dropdown,
            VueMonthlyPicker
        },
        computed: {
            startLimit: function () {
                return moment(this.endMonth).add(-13, 'M');
            },
            endLimit: function () {
                return moment(this.startMonth).add(13, 'M');
            },
            /**
             * Bench report allocation data from store
             */
            allocations: function () {
                return this.$store.state.reports.benchAllocations;
            },
            /**
             * Bench report cosultant list from store
             */
            relations: function () {
                return this.$store.state.reports.benchRelations;
            },
            /**
             * Get the bench overview filter data from store
             */
            filter: function () {
                return this.$store.state.reports.filter;
            },
            /**
             * if loading more rows for bench overview
             */
            isLoadingMoreRows: function () {
                return this.$store.state.reports.loadingMoreBenchRows;
            },
            /**
             * Model binding for consultant search
             */
            consultantSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.consultant);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.consultant,
                        value: value
                    };
                    this.$store.commit("setBenchSearchData", data);
                }
            },
            /**
             * Model binding for sap number search
             */
            sapSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.sap_no);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.sap_no,
                        value: value
                    };
                    this.$store.commit("setBenchSearchData", data);
                }
            },
            /**
             * Model binding for customer search
             */
            customerSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.customer);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.customer,
                        value: value
                    };
                    this.$store.commit("setBenchSearchData", data);
                }
            },
            /**
             * Model binding for OE search
             */
            oeSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.oe);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.oe,
                        value: value
                    };
                    this.$store.commit("setBenchSearchData", data);
                }
            },
            /**
             * Model binding for engagement search
             */
            engagementSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.filter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.engagement);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.engagement,
                        value: value
                    };
                    this.$store.commit("setBenchSearchData", data);
                }
            },
        },
        beforeMount() {
            this.requestApis();
        },
        methods: {
            /**
             * Request for data
             */
            requestApis: function () {
                let filter = this.initFilter();
                this.$store.dispatch("fetchBenchReport", filter);
            },
            initFilter: function () {
                let filter = _.cloneDeep(this.filter);
                //console.log(filter, moment().startOf("month").format("MM-YYYY"));
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                //console.log(filter, moment().startOf("month").format("MM-YYYY"));
                return filter;
            },
            /**
             * set the table width
             */
            setTableWidth: function () {
                setTimeout(() => {
                    let element = document.querySelector('.report-allocations .gm-scroll-view');
                    if (element) {
                        // this.masterTableWidth = element.scrollWidth;
                        this.masterTableWidth = 271 * this.allocations.length;
                    }
                }, 200);
            },
            /**
             * Handle the scroll event on report relation section
             * Get the scroll height and on limit, fetch data
             */
            handleScroll: function () {
                // get the parent element
                let parent = document.getElementById('bench-scroll-table');
                // get the child element having scroll
                let child = parent.getElementsByClassName('scroll-sync-container');
                // get the first child, first having the scroll
                let firstChild = child[0];
                
                
                
                // on scrolling the child
                firstChild.addEventListener('scroll', () => {
                    // console.log(height, settings.load_more_height_report, "scroll")
                    // get the scroll height
                    let height = firstChild.scrollHeight - firstChild.scrollTop;
                    // console.log(height, settings.load_more_height_report, firstChild.scrollHeight, firstChild.scrollTop);
                    // scrolled down
                    if (height <= settings.load_more_height_report) {
                        // load more data
                        // this.loadMoreResults();
                    }
                })
            },
            /**
             * Load more report data
             */
            loadMoreResults: function () {
                if (this.loadMore) {
                    this.loadMore = false;
                    this.$store.dispatch("fetchMoreBenchReport").then(
                        () => {
                            this.loadMore = true;
                        }
                    );
                }
            },
            /**
             * Request with the search result once the user stopped typing
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the bench report with the search data
                    this.$store.dispatch("fetchBenchReport", filter);
                }, 700);
            },
            /**
             * Sort table on click
             * @param column
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setBenchSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'ASC') {
                    this.$store.commit("setBenchSort", {column: searchKeys[column], order: 'DESC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'DESC') {
                    this.$store.commit("setBenchSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                }
                if (this.relations && this.relations.length && this.relations.length > settings.initial_forecast_row_count) {
                    rowCount = this.relations.length;
                }
                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchBenchReport", filterData);
            },

            /**
             * Mouse wheel on right table should scroll the horizontal area.
             * @constructor
             */
            HeadHorizontalScroll: function () {
                let ScrollElement = this.$refs.masterHeadScroll,
                    scrollableElement = document.querySelector('.report-alloc-benchoverview .gm-scroll-view'),
                    i = 0;

                //Mouse wheel and scroll event
                ScrollElement.addEventListener('wheel', function (e) {
                    //When dragging to left side
                    if (e.deltaY < 0 && !e.shiftKey) {
                        if (i >= 0) {
                            //if Scroll left == 0
                            scrollableElement.scrollLeft = i;
                            i = i - 50;
                        } else {
                            i = 0;
                        }

                    }
                    //Mouse wheel and horizontal scroll for allocation's headers
                    else if (e.deltaY > 0 && !e.shiftKey) {
                        if (i <= scrollableElement.scrollWidth) {
                            //if Scroll left !== end of the div
                            scrollableElement.scrollLeft = i;
                            i = i + 50;
                        } else {
                            i = scrollableElement.scrollWidth
                        }
                    }
                })
            },
            /**
             * Fetch the current data again
             */
            fetchUpdatedReport: function () {
                // clone the current filter
                let filter = _.cloneDeep(this.filter);
                // set the page number to one
                filter.pageNumber = 1;
                // set the row count
                if (this.benchOverviewRelations && this.benchOverviewRelations.length > settings.initial_forecast_row_count) {
                    filter.pageSize = this.benchOverviewRelations.length;
                } else {
                    filter.pageSize = settings.initial_forecast_row_count;
                }
                // send request
                this.$store.dispatch("fetchBenchReport", filter);
            },
            exportExcel: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                if (this.benchOverviewRelations && this.benchOverviewRelations.length > settings.initial_forecast_row_count) {
                    filter.pageSize = this.benchOverviewRelations.length;
                } else {
                    filter.pageSize = settings.initial_forecast_row_count;
                }
                // send request
                this.$store.dispatch("exportBench", filter);

            },


            /* Custom horizontal scroll function when resizing the page to laptop or tab view */
            customHorizontalbar: function () {
                let oldy = 0;

                //Get scrollable div
                // let parentScrollElement = this.$refs.verticalscrollset.$el;

                let parentScrollElement;
                if (this.$refs.verticalscrollset.$el != null && this.$refs.verticalscrollset.$el != undefined) {
                    parentScrollElement = this.$refs.verticalscrollset.$el;
                }

                let customScrollElement = parentScrollElement.querySelector('.scroll-sync-container');
                customScrollElement.classList.add('qtime-h-scroll');
                /*Now, <div class="scroll-sync-container qtime-h-scroll"></div> is the scrollable div */

                let customScrollElementWidth = customScrollElement.getBoundingClientRect(),
                    customScrollElementRemainWidth = 0;


                //Create div and scroll panel for the scrollable div
                let scrollableFnWrap = document.createElement('div');
                scrollableFnWrap.id = "qtime-h-scroll-bar";
                scrollableFnWrap.classList.add('qtime-h-scroll-bar-class');
                customScrollElement.appendChild(scrollableFnWrap);

                //Create scroll thumb and append it into the  `scrollableFnWrap` div
                let scrollableThumb = document.createElement('div');
                scrollableThumb.id = "q-time-scroll-thumb";
                //scrollableThumb.setAttribute('draggable', true);
                scrollableFnWrap.appendChild(scrollableThumb);

                //setting thumb width, using thumb width function
                setTimeout(function () {
                    thumbWidthFn();
                }, 500);


                //Thumb scroll event, used mousedown, mouseup and mousemove.    
                scrollableThumb.onmousedown = function (e) {
                    let shiftX = e.clientX - scrollableThumb.getBoundingClientRect().left;
                    moveAt(e.pageX, e.pageY);
                    oldy = e.pageY;

                    //Move function, it scrolls the area.
                    function moveAt(pageX) {
                        customScrollElement.scrollLeft = pageX - shiftX;
                        scrollableThumb.style.transform = "translateX(" + customScrollElement.scrollLeft + "px)";
                    }

                    //EventLintener trigger function
                    function onMouseMove(e) {
                        moveAt(e.pageX, e.pageY);
                    }

                    //Mouse move event
                    document.addEventListener('mousemove', onMouseMove);

                    //Mouseup event, after scolling and once the mouse is up, set the position and points.
                    document.addEventListener('mouseup', () => {
                        document.removeEventListener('mousemove', onMouseMove);

                    })
                }

                // Horizontal scroll support event method.
                scrollableThumb.ondragstart = function () {
                    return false;
                }

                //Call the method when resize event happens.
                customScrollElement.addEventListener('scroll', function (e) {
                    SyncScrollDrag(e);
                });


                // Sync scroll, Both area scroll and thumb scroll should sync.
                function SyncScrollDrag() {
                    scrollableThumb.style.transform = "translateX(" + customScrollElement.scrollLeft + "px)";
                }

                //Thumb width function 
                function thumbWidthFn() {
                    if (customScrollElement.scrollWidth >= 692) {
                        //Remaining width
                        customScrollElementRemainWidth = customScrollElement.scrollWidth - customScrollElementWidth.width;
                        //adding thumb size as per screen size & scrollWidth calculation
                        scrollableThumb.style.width = (customScrollElementWidth.width - customScrollElementRemainWidth) + "px";
                    }

                    // For small screens (< 900)
                    if (customScrollElementWidth.width < 692) {
                        scrollableThumb.style.width = ((customScrollElement.scrollWidth - customScrollElementWidth.width) / 10) + "px";
                    }

                }
            },
            //Remove scrollbar and thumb as init function.
            //to avoid duplication when resizing
            clearAllElements: function () {
                try {
                    // let clearingNavBar = document.getElementById('qtime-h-scroll-bar');
                    let clearingNavBar = document.querySelectorAll('.qtime-h-scroll-bar-class');
                    clearingNavBar.forEach((i) => {
                        i.remove();
                    });

                } catch (e) {

                }

            },

            resetAllocPos: function () {
                let el = document.querySelector('.report-alloc-benchoverview .master-report-table');
                if (el != null) {
                    el.scrollLeft = 0;
                }
            },

            resetScrollLeft: function () {
                let scrollViewElement = document.querySelector('.report-alloc-benchoverview .gm-scroll-view');
                scrollViewElement.scrollLeft = 0;
                this.masterTableWidth = scrollViewElement.scrollWidth;
            },


            //call listeners
            callListeners: function () {
                this.clearAllElements();
                // this.customHorizontalbar();
            },
            
              wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        },
        updated() {
            this.setTableWidth();
            this.wrappingLap();
        },
        mounted() {


            this.handleScroll();
            //Relation scroll when resizing
            let scrollElement = this.$refs.verticalscrollset.$el;
            let overflowContainer = scrollElement.querySelector('.scroll-sync-container');
            let scrollElementHead = document.querySelector('.master-t-head-b');
            //Sync scroll in laptop view
            overflowContainer.addEventListener('scroll', function (node) {
                scrollElementHead.scrollLeft = node.target.scrollLeft;
            });

            //sync scroll in laptop view
            scrollElementHead.addEventListener('scroll', function (node) {
                overflowContainer.scrollLeft = node.target.scrollLeft;
            });


            window.addEventListener("resize", this.callListeners);


            // Horizontal scroll for allocation in benchoverview
            setTimeout(() => {
                this.HeadHorizontalScroll()
                // this.customHorizontalbar();
            }, 500);

            document.body.classList.add('consulant-workload-body');
        },
        beforeDestroy() {
            //Removing resize event listener in beforeDestroy() hook
            window.removeEventListener("resize", this.callListeners);
        },
        destroyed() {
            document.body.classList.remove('consulant-workload-body');
        },
        watch: {
            allocations: function () {
                this.setTableWidth();
                // Set allocation's left position as zero
                this.resetScrollLeft();
            },
            consultantSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                    // Set allocation's left position as zero
                    this.resetScrollLeft();
                }
            },
            sapSearch: function (value) {
                if (!value || !value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.sap_no = false;
                    this.submitSearchResult();
                    // Set allocation's left position as zero
                    this.resetScrollLeft();
                } else this.searchError.sap_no = !!value;
            },
            customerSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                    // Set allocation's left position as zero
                    this.resetScrollLeft();
                }
            },
            oeSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult();
                    // Set allocation's left position as zero
                    this.resetScrollLeft();
                }
            },
            engagementSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.employment = false;
                    this.submitSearchResult();
                    // Set allocation's left position as zero
                    this.resetScrollLeft();
                } else this.searchError.employment = !!value;
            },
            startMonth: function () {
                if (this.startMonth && this.endMonth && this.startMonth <= this.endMonth) {
                    this.$store.commit("setBenchFromDate", this.startMonth.format('MM-YYYY'));
                    this.fetchUpdatedReport();
                    this.resetAllocPos();
                    //Updating table width 
                    this.setTableWidth();
                }
            },
            endMonth: function () {
                if (this.startMonth && this.endMonth && this.startMonth <= this.endMonth) {
                    this.$store.commit("setBenchToDate", this.endMonth.format('MM-YYYY'));
                    this.fetchUpdatedReport();
                    this.resetAllocPos();
                    //Updating table width 
                    this.setTableWidth();
                }
            },
            engagement: function () {
                this.$store.commit("setBenchEngangementRange", this.engagement);
                this.fetchUpdatedReport();
            }
        }
    }
</script>
<style scoped>
    .master-table {
        height: calc(100vh - 215px);
        min-height: calc(100vh - 215px);
    }

    .date-range {
        display: flex;
        /*flex-wrap: wrap;*/
        padding-right: 49px;
        /* padding-top: 37px; //old code */
        padding-top: 17px;

    }

    .date-range > div {
        margin-left: 10px;
    }

    .sub-header {
        display: flex;
        justify-content: space-between;
    }

    .error-border {
        border: 1px solid red;
    }

    /*style for range filter*/
    span.range-per {
        position: relative;
        top: 9px;
        bottom: 0px;
        left: 4px;
        /* margin: 0 auto; */
    }


    .engagement-range {
        display: flex;
        /*flex-wrap: wrap;*/
        /* padding-top: 37px; //old code */
        padding-top: 17px;

    }

    .engagement-range > div {
        margin-left: 10px;
    }


    

    @media screen and (max-width: 768px) {
        .master-table {
            height: calc(100vh - 295px);
            min-height: calc(100vh - 295px);
        }
    }


    @media screen and (max-height: 900px) {
        .master-table {
            height: calc(100vh - 295px);
            min-height: calc(100vh - 295px);
        }
    }
</style>

